import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfduu8xcyk: FaireProductEntity = {
  token: "p_nfduu8xcyk",
  type: "product",
  name: "Palo Santo  Stretchable Bracelet 6mm Beads--Sustainable",
  brandToken: "b_4w78fajgal",
  brandName: "Meraki Gemstones",
  imageUrl:
    "https://cdn.faire.com/fastly/fa92cb93a1fe4e4a83fda804ae656404958be7397ad7bd50c19a649049250fac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c283bd158a97b61593a5125f9ec1b8156c1de1bd734bfcc1e6d3d2d706624198.jpeg",
    "https://cdn.faire.com/fastly/fa2af685619ca2ac4847a14b75870e856fb07b1e5e15f60b2e33a22d1ce1adba.jpeg",
    "https://cdn.faire.com/fastly/18e3b90a750a5a553c827ddded727235632457b9fcccaee9a5c760389260e684.png",
  ],
  priceDollars: 9.7,
  description:
    "Palo Santo stretchable bracelet made with 6mm sized beads.\n*All natural.\n*7 inches in length.\n*Sustainably Harvested\n\nOur Palo Santo bracelets are 100% Natural and Sustainably Harvested.  These ultra fragrant Palo Santo bracelets are harvested from trees that have fallen, and are never cut down by force.  The village that farms and collects these trees are accredited by the Peruvian Government.\n\nThis picture is an representation of the type and quality of the gemstone you will be receiving.  As you know, there are slight variations due to the natural character of this product.",
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:28.825Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
